import { useEffect } from 'react';
import { useMutableRef } from '../useMutableRef/useMutableRef';
export function useClickOutside(_a) {
    // Аргументы вынесены в рефки за тем, чтобы не пересоздавать подписку `mousedown` при кажом чихе.
    // Бывают кейсы когда на странице несколко `useClickOutside` и один вызывает рендер,
    // А второй не успевает отрабатывать а просто пересоздается
    // С такой реализацией пересоздание только при удалении из дома, а аргументы всегда актуалны.
    var isActive = _a.isActive, ignoreClicksInsideRefs = _a.ignoreClicksInsideRefs, handler = _a.handler;
    var handlerRef = useMutableRef(handler);
    var ignoreClicksInsideRefsRef = useMutableRef(ignoreClicksInsideRefs);
    var isActiveRef = useMutableRef(isActive);
    useEffect(function () {
        var handleClick = function (event) {
            var _a, _b;
            if (!isActiveRef.current) {
                return;
            }
            var target = event.target;
            var shouldCallHandler = (_a = ignoreClicksInsideRefsRef.current) === null || _a === void 0 ? void 0 : _a.every(function (ref) { var _a; return !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(target)); });
            shouldCallHandler && ((_b = handlerRef.current) === null || _b === void 0 ? void 0 : _b.call(handlerRef, event));
        };
        document.addEventListener('mousedown', handleClick);
        return function () {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
}
